export default {
  MuiDrawer: {
    styleOverrides: {
      paper: {
        padding: '0px 0px 0px 0px',
        border: 'none !important',
        borderRadius: '0px',
        boxShadow: 'none',
        backgroundColor: '#F0F0F0'
      },
      paperAnchorDockedLeft: {
        borderRight: 'solid 1px #D9D9D9 !important'
      }
    }
  }
};
